import fetch from "@/api/fetch";

export default async function getMenu(param: any) {
  const { data } = await fetch.get("/menu", { ...param });
  return data;
}
